import { BillingMetricConsumption } from '../metrics/BillingMetricConsumption';

export class DailyMeuConsumption {
  botName!: string;
  botIdentity!: string;
  metricConsumption!: BillingMetricConsumption[];

  constructor(dailyMeuConsumption: Partial<DailyMeuConsumption>) {
    Object.assign(this, dailyMeuConsumption);
  }
}
